<div class="inner-icon right-icon" [class.is-valid]="valid" [class.is-invalid]="invalid">
  <i class="far fa-calendar fa-sm" (click)="datePicker.toggle()"></i>
  <input
    class="form-control {{ props.cssClass }}"
    ngbDatepicker
    #datePicker="ngbDatepicker"
    [id]="key"
    [placeholder]="props.placeholder"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [class.is-valid]="valid"
    [class.is-invalid]="invalid"
    (click)="datePicker.toggle()"
    (dateSelect)="change()"
  />
</div>
